import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, CmsService, LanguageService, OccEndpointsService, ProductService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { CheckoutService } from "src/app/shared/modules/checkout/checkout.service";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { PersonalizationBannerComponent } from "src/app/shared/modules/personalization-banner/personalization-banner.component";
import { DataLayerService } from "src/app/shared/services/data-layer.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { AccountOverviewService } from "../account-overview.service";
import { ViewAndReorderProductsComponent } from "./view-and-reorder-products/view-and-reorder-products.component";

@Component({
    selector: 'app-account-overview',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './account-overview.component.html',
    styleUrls: ['./account-overview.component.scss'],
    standalone: false
})
export class AccountOverviewComponent implements OnInit, OnDestroy {
  accountNumber: string = null;
  compNameAdBanner = 'SanofiAccountOverviewBannerComponent4';
  compNameAdBanner2 = 'SanofiAccountOverviewBannerComponent2';
  compNameAdBanner3 = 'SanofiAccountOverviewBannerComponent3';
  compNameAdBanner6 = 'SanofiAccountOverviewBannerComponent6';
  compNameAdBanner1 = 'SanofiAccountOverviewBannerComponent';
  cmsResponse: any;
  productCodes: any;
  prodcutsInfo: any = [];
  prodDocs: any = [];
  prodDocus: any = [];
  fluResevartion: boolean;
  userAccSub: Subscription;
  modalSubscribtion
  modalSubscription: Subscription;
  popupSubscription: Subscription;
  baseUrl: any;
  reorderBannerUrl: string;
  cmsReorderResponse: any;
  reorderProdSub: Subscription;
  reorderProductListSub: Subscription;
  priceDetails: any;
  isLocationSelected: boolean;
  selectedLocations: any;
  LocationListSub: Subscription;
  userDetails: any;
  userDataSub: Subscription;
  cartItemsSub: Subscription;
  cartItems: any = [];
  cartId: any;
  modalRef: any;
  baseSiteId = '';

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly cmsData: CmsService,
    protected readonly productService: ProductService,
    private readonly checkoutService: CheckoutService,
    private readonly sanitizer: DomSanitizer,
    private readonly lang: LanguageService,
    private readonly modal: NgbModal, private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService, private readonly locStripService: LoactionStripService,
    private readonly user: UserAccountFacade,
    private readonly baseSiteService: BaseSiteService, private readonly sharedService: SharedService,
    private readonly customProfService: CustomProfileAndPreferencesService,
    public readonly _dataLayerService: DataLayerService
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('DataLayerPushNeedLogin')) {
      this._dataLayerService.addtoDataLayer('login', localStorage.getItem('userId')?.replace(/['"]+/g, ''));
      localStorage.removeItem('DataLayerPushNeedLogin');
    }

    this.modalSubscription = this.cmsData.getContentSlot('SanofiModelWindowSlot').subscribe((res) => {
      if (res?.components[0]?.uid) {
        this.popupSubscription = this.cmsData.getComponentData(res?.components[0]?.uid).subscribe((res2: any) => {
          if (res2?.showPopup === 'true') {
            this.modal.open(PersonalizationBannerComponent, {
              centered: true,
              windowClass: 'personalization-banner'
            });
          }
        })
      }
    });
    this.popupSubscription?.unsubscribe();
    this.modalSubscription?.unsubscribe();

    this.lang.getActive().subscribe((res) => {
      if (res) {
        this.prodcutsInfo = [];
      }
    });

    this.customProfService._userAccountData.pipe(filter(res => !!res), map(({ defaultB2BUnit }) => ({ uid: defaultB2BUnit.uid })), take(1))
      .subscribe((res: any) => {
        if (this.accountNumber === null) {
          this.accountNumber = res;
          localStorage.setItem('user_account_id', res?.uid);
          this.cdr.detectChanges();
        }
      });

    this.baseUrl = this.occEndPoint.getBaseUrl({ baseUrl: true, prefix: false, baseSite: false, });
    this.cmsData
      .getComponentData('ProductMonographComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
      });

    this.LocationListSub = this.locStripService.emitSelectedLocs.pipe(filter(locs => !!locs?.length), take(1)).subscribe(locsData => {
      this.isLocationSelected = !!locsData?.length;
      this.selectedLocations = locsData;
      let arrAccountNumber = this.selectedLocations.map((item) => item.accountNumber)
      this.acService.reorderProducts('TimeToReorderComponent', arrAccountNumber);
      this.reorderProdSub = this.acService.userReorderProducts$.pipe(filter(prods => !!prods), take(1)).subscribe((res) => {
        if (res !== null) {
          this.cmsReorderResponse = res;
          if (this.cmsReorderResponse?.image?.url) {
            this.reorderBannerUrl = `${this.baseUrl}${this.cmsReorderResponse?.image?.url}`;
            if (this.cmsReorderResponse?.reorderProducts) {
              this.acService.getReorderProductList(this.cmsReorderResponse?.reorderProducts);
            }
            this.cdr.detectChanges();
          }
        }
      })
      this.userDataSub = this.user.get().subscribe((res) => {
        this.userDetails = res;
      });
      if (this.userDetails?.janrainIdentifier !== undefined) {
        localStorage.setItem('user_id', this.userDetails?.janrainIdentifier)
      }
      this.plpService.getCarts(this.userDetails?.uid);
      this.cartItemsSub = this.plpService.cartItems$.subscribe((res) => {
        if (res) {
          this.cartItems = res?.carts;
          this.cartItems = this.cartItems?.filter((item) => item?.saveTime === undefined);
          this.cartItems = this.cartItems && this.cartItems?.length > 0 ? this.cartItems[this.cartItems?.length - 1] : [];
          this.cartId = this.cartItems?.code;
        }
      });
      this.cdr.detectChanges();
    });

    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
  }

  navigateToAccountDetails() {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Account information');
  }

  productMonograph() {
    this.productCodes = this.cmsResponse?.productCodes;
    this.productCodes = this.productCodes?.split(' ');
    this.productCodes?.forEach((element) => {
      this.productService.get(element).subscribe((res) => {
        if (res) {
          this.prodcutsInfo.push(res);
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnDestroy() {
    this.userAccSub?.unsubscribe();
    this.reorderProdSub?.unsubscribe();
    this.reorderProductListSub?.unsubscribe();
  }

  viewReorderPopup() {
    this.getViewProductList();
  }

  getViewProductList() {
    this.reorderProductListSub = this.acService.reorderProductList$.subscribe((res) => {
      if (res !== null) {
        const productCodeArr = res?.products.map(item => item.code);
        this.plpService.getCarts(this.userDetails?.uid);
        this.pricingAPI(productCodeArr, res?.products);
      }
    })
  }

  pricingAPI(productCodeArr, productList) {
    // Pricing API call
    this.reorderProductListSub?.unsubscribe();
    if (!!this.selectedLocations !== this.selectedLocations && this.selectedLocations?.length === 1) {
      let req = {
        productCodes: productCodeArr,
        b2bUnitId: this.selectedLocations[0].accountNumber
      };
      this.plpService.getProductPrices(req).subscribe(prices => {
        if (prices) {
          this.priceDetails = prices.priceAndAvailability;
          this.priceDetails.forEach(element => {
            productList.map((data) => {
              if (element.code === data.code) {
                data.priceDetailsObj = element;
                data.price = element.price;
                data.contract = element.conditions;
                data.selectedContractGroup = data.contract ? data.contract[0] : '';
                data.selectedContractId = data.contract ? data.contract[0].contractId : '';
              }
            })
          });
		  this.modalRef = this.modal.open(ViewAndReorderProductsComponent, {
			  centered: true,
			  backdrop: 'static',
			  windowClass: `${this.baseSiteId}`
		  });
          this.modalRef.componentInstance.reoderProductList = productList;
          this.modalRef.componentInstance.selectedLocations = this.selectedLocations;
          this.modalRef.componentInstance.cartId = this.cartId;
          this.modalRef.componentInstance.userDetails = this.userDetails;
          this.cdr.detectChanges();
        }
      });
    }
  }
}
